export const MainSecondExpansionText = {
  first: {
    title: '常に、安心・安全',
    description: [
      '常にパスワードを付与する為、情報漏洩のリスクを減らすことができます。',
    ],
  },
  second: {
    title: '共有作業が楽にできる',
    description: [
      '設定いただいた後は、共有リンクを検知して、システムが自動的にパスワードを設定・通知します。',
      '利用者によるパスワードの設定漏れの心配もありません。',
      'リラックスして作業が行えます。',
    ],
  },
  therd: {
    title: ['個別のインフラ環境コストは', '必要ありません'],
    description: [
      '本サービスはcloudサービスとしてご提供します。',
      'お客様に個別のインフラ環境をご用意いただく必要はありません。',
      '通常通りWEBブラウザ、BoxDriveスマホ等にて共有リンクを作成してご利用いただけます。',
    ],
  },
  fourth: {
    title: '「ダウンロード不可」の活用',
    description: [
      '社外への提案資料など、閲覧はしてほしいがファイル自体は渡したくない場合に、自動で「プレビューのみ」に設定されるため安心です。',
    ],
  },
  fifth: {
    title: '「有効期限」の活用',
    description: [
      'プロジェクト終了後もリンクが生き残ってしまうリスクを排除。自動的にリンクが無効化されるため、管理の手間がいりません。',
    ],
  },
};
